import { Controller, useFormContext } from 'react-hook-form';
import * as React from 'react';
import Select, { SelectProps } from '@/components/@IntranetLibrary/Select';

export default function RHFSelect<T extends string>(
  props: SelectProps<T> & {
    name: string;
  },
) {
  const { control } = useFormContext();
  const { name, disabled, ...selectProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select
          {...selectProps}
          {...field}
          disabled={disabled ?? field.disabled}
        />
      )}
    />
  );
}
